export default __webpack_public_path__ + "img/pin_icons/damper_w.svg";